import { render, staticRenderFns } from "./EvaluacionData.vue?vue&type=template&id=60998288&"
import script from "./EvaluacionData.vue?vue&type=script&lang=js&"
export * from "./EvaluacionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports